import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: null,
    userEmail: null,
    userAuthToken: null,
    userIsCoachOrAdmin: false,
    coaches: null
  },
  mutations: {
    setPatients (state, payload) {
      state.patients = payload
    },
    setUser (state, payload) {
      state.userId = payload.userId
      state.userEmail = payload.userEmail
      state.userAuthToken = payload.userAuthToken
      state.userIsCoachOrAdmin = payload.userIsCoachOrAdmin
    },
    setCoaches (state, payload) {
      state.coaches = payload
    },
    resetStore (state) {
      state.userId = null
      state.userEmail = null
      state.userAuthToken = null
      state.userIsCoachOrAdmin = false
      state.coaches = null
    }
  },
  actions: {
    saveCoaches ({ commit }, payload) {
      return new Promise(
        resolve => {
          commit(
            'setCoaches',
            payload.hasOwnProperty('coaches')
              ? payload.coaches
              : payload
          )
          resolve()
        }
      )
    }
  }
})
